<template>
  <div>
    <div @click="dialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-top-transition"
      persistent
    >
      <v-card>
        <v-toolbar color="primary" dark fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-car</v-icon>
            {{ $i18n.t("Select Trip(s)") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Pickup Date From')"
                v-model="filter.pickDateFrom"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <z-time-picker
                :label="$i18n.t('Pickup Time From')"
                v-model="filter.pickTimeFrom"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Pickup Date Till')"
                v-model="filter.pickDateTill"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <z-time-picker
                :label="$i18n.t('Pickup Time Till')"
                v-model="filter.pickTimeTill"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <v-text-field
                :label="$i18n.t('Trip No')"
                class="purple-input"
                v-model="filter.tripNo"
              />
            </v-col>
            <v-col cols="12" md="2" sm="4">
              <v-select
                :label="$i18n.t('Status')"
                class="purple-input"
                v-model="filter.status"
                :items="statusList"
              />
            </v-col>
            <v-col cols="12" md="2" sm="4" class="text-right pull-right my-3">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="black"
                    text
                    fab
                    x-small
                    @click="clearSearch()"
                    style="margin-right: 2px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                x-small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn @click="proccedWithCehcked">Select</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-btn
            v-if="grid != undefined && !grid.records"
            class="text-center secondary--text pa-10"
            text
            color="primary"
            style="width: 100%"
            :loading="loading"
            >{{ $i18n.t("No records available") }}</v-btn
          >
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-simple-table dense v-if="grid.records">
                <thead>
                  <tr>
                    <th class="primary--text">
                      <v-checkbox v-model="selectAll" />
                    </th>
                    <th class="primary--text">{{ $i18n.t("Booking No") }}</th>
                    <th class="primary--text">{{ $i18n.t("Client") }}</th>
                    <th class="primary--text">
                      {{ $i18n.t("Date") }} / {{ $i18n.t("Time") }}
                    </th>
                    <th class="primary--text">{{ $i18n.t("Source") }}</th>
                    <th class="primary--text">{{ $i18n.t("Vehicle") }}</th>
                    <th class="primary--text">{{ $i18n.t("Driver") }}</th>
                    <th class="primary--text">{{ $i18n.t("Status") }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="trip in grid.rows" :key="trip._id">
                    <td>
                      <v-checkbox v-model="trip.selected" />
                    </td>

                    <td>{{ trip.tripNo }}</td>

                    <td>{{ trip.clientName }}</td>

                    <td>
                      {{ trip.startTime | moment("HH:mm DD MMM") }} <br />{{
                        trip.endTime | moment("HH:mm DD MMM")
                      }}
                    </td>

                    <td>{{ trip.src.addressLine }}</td>

                    <td>
                      {{ trip.vehicle ? trip.vehicle.vehicleType : null }}
                      <br />
                      {{ trip.vehicle ? trip.vehicle.regNo : null }}
                    </td>

                    <td>
                      {{ trip.driver ? trip.driver.name : null }}
                      <br />
                      {{ trip.driver ? trip.driver.phone : null }}
                    </td>
                    <td>{{ trip.invoiceStatus }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-pagination
                v-if="grid.records"
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "TripSelect",
  props: {
    corp_id: {
      default: null,
    },
    client_id: {
      default: null,
    },
    vendor_id: {
      default: null,
    },
    supplier_id: {
      default: null,
    },
    value: {
      default: null,
    },
    idOnly: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: "Trips",
    },
    multiple: {
      default: false,
    },
    clearable: {
      default: false,
    },
    btn: {
      default: false,
    },
    prependIcon: {
      default: undefined,
    },
    prependInnerIcon: {
      default: undefined,
    },
    trips: {
      default: undefined,
    },
    rules: {
      default: () => [],
    },
    statuses: {
      default: null,
    },
    selectedTrip: {
      default: null,
    },
    forBill: {
      default: null,
    },
  },
})
export default class TripSelect extends (Vue, Themeable) {
  grid = {};
  rows = 20;
  url = "/api/corp/trips/data/post?rows=";
  filter = {
    tripNo: null,
    client_id: null,
    vendor_id: null,
    supplier_id: null,
    pickDateFrom: null,
    pickTimeFrom: null,
    pickDateTill: null,
    pickTimeTill: null,
    statuses: null,
    status: null,
    regNo: null,
    driverName: null,
    driverCC: null,
    driverPhone: null,
    forBill: null,
  };
  selectAll = false;
  supplier = null;
  country = null;
  on = null;
  page = 1;
  dialog = false;
  vehicle = null;
  vehicles = [];
  filter = "";
  loading = false;
  statusList = [];

  @Watch("selectAll")
  onSelectAll() {
    if (this.grid && this.grid.rows) {
      for (let i = 0; i < this.grid.rows.length; i++) {
        this.grid.rows[i].selected = this.selectAll;
      }
    }
  }

  proccedWithCehcked() {
    const callback = [];
    if (this.grid && this.grid.rows) {
      for (let i = 0; i < this.grid.rows.length; i++) {
        if (this.grid.rows[i].selected) {
          const data = this.grid.rows[i];
          callback.push(data);
        }
      }
    }
    this.$emit("selectedTrip", callback);
    this.dialog = false;
  }

  async mounted() {
    this.filter = {
      tripNo: null,
      client_id: null,
      vendor_id: null,
      supplier_id: null,
      pickDateFrom: null,
      pickTimeFrom: null,
      pickDateTill: null,
      pickTimeTill: null,
      statuses: null,
      status: null,
      regNo: null,
      driverName: null,
      driverCC: null,
      driverPhone: null,
      forBill: null,
    };
  }

  async showPage(page) {
    this.page = page;
    const filt = this.statuses ? "&statuses=" + this.statuses : "";
    this.loading = true;
    this.grid = {};
    const data = await doPost(
      this.url + this.rows + filt + this.filterUrl + "&page=" + page,
      { notinvalues: this.trips }
    );
    this.loading = false;
    for (let i = 0; i < data.rows.length; i++) {
      data.rows[i].selected = false;
    }
    this.grid = data;
  }

  async clearSearch() {
    this.filter = {
      tripNo: null,
      client_id: null,
      vendor_id: null,
      supplier_id: null,
      pickDateFrom: null,
      pickTimeFrom: null,
      pickDateTill: null,
      pickTimeTill: null,
      statuses: null,
      status: null,
      regNo: null,
      driverName: null,
      driverCC: null,
      driverPhone: null,
      forBill: null,
    };
    this.page = 1;
    this.search();
  }

  async search() {
    this.filter.supplier_id = this.supplier_id;
    this.filter.forBill = this.forBill;
    let filterUrl = "";
    if (this.filter.tripNo) filterUrl += "&tripNo=" + this.filter.tripNo;
    if (this.filter.client_id) filterUrl += "&corp_id=" + this.filter.client_id;
    if (this.filter.vendor_id)
      filterUrl += "&vendor_id=" + this.filter.vendor_id;
    if (this.filter.supplier_id)
      filterUrl += "&supplier_id=" + this.filter.supplier_id;
    if (this.filter.pickDateFrom)
      filterUrl += "&pickDateFrom=" + this.filter.pickDateFrom;
    if (this.filter.pickTimeFrom)
      filterUrl += "&pickTimeFrom=" + this.filter.pickTimeFrom;
    if (this.filter.pickDateTill)
      filterUrl += "&pickDateTill=" + this.filter.pickDateTill;
    if (this.filter.pickTimeTill)
      filterUrl += "&pickTimeTill=" + this.filter.pickTimeTill;
    if (this.filter.statuses) filterUrl += "&statuses=" + this.filter.statuses;
    if (this.filter.regNo) filterUrl += "&vehicle.regNo=" + this.filter.regNo;
    if (this.filter.driverName)
      filterUrl += "&driver.name=" + this.filter.driverName;
    if (this.filter.driverCC)
      filterUrl += "&driver.countryCode=" + this.filter.driverCC;
    if (this.filter.driverPhone)
      filterUrl += "&driver.phone=" + this.filter.driverPhone;
    if (this.filter.forBill) filterUrl += "&forBill=true";
    this.filterUrl = filterUrl;
    await this.showPage(1);
  }

  setStatusList() {
    this.statusList = [];
    if (this.statuses) {
      if (this.statuses.indexOf("1") != -1)
        this.statusList.push({ value: 1, text: "Open" });
      if (this.statuses.indexOf("2") != -1)
        this.statusList.push({ value: 2, text: "Supplier Assigned" });
      if (this.statuses.indexOf("3") != -1)
        this.statusList.push({ value: 3, text: "Ready" });
      if (this.statuses.indexOf("4") != -1)
        this.statusList.push({ value: 4, text: "In Service" });
      if (this.statuses.indexOf("5") != -1)
        this.statusList.push({ value: 5, text: "Breakdown" });
      if (this.statuses.indexOf("6") != -1)
        this.statusList.push({ value: 6, text: "Completed" });
      if (this.statuses.indexOf("7") != -1)
        this.statusList.push({ value: 7, text: "Cancelled" });
    } else {
      this.statusList = [
        { value: 1, text: "Open" },
        { value: 2, text: "Supplier Assigned" },
        { value: 3, text: "Ready" },
        { value: 4, text: "In Service" },
        { value: 5, text: "Breakdown" },
        { value: 6, text: "Completed" },
        { value: 7, text: "Cancelled" },
      ];
    }
  }

  @Watch("dialog")
  async onDialogChange(val) {
    if (val) {
      try {
        this.setStatusList();
        this.search();
      } catch (e) {
        common.setError(e.message);
      }
    }
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.v-dialog > .v-card > .v-card__text {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-card .v-card__actions {
  padding-top: 5px;
  padding-bottom: 5px;
}
.v-dialog .v-card .v-card__title {
  padding-top: 10px;
}
</style>
